import type { UserDataAction, UserDataState } from './types'
import { UserDataActionTypes } from './types'

export const initialUserDataState: UserDataState = {
  uid: null,
  initialized: false,
  loading: false,
  error: null
}

export function userDataReducer(state: UserDataState, action: UserDataAction): UserDataState {
  switch (action.type) {
    case UserDataActionTypes.USER_DATA_INIT:
      return {
        ...state,
        uid: action.payload,
        loading: true,
        error: null,
        initialized: false
      }
    case UserDataActionTypes.USER_DATA_READY:
      return {
        ...state,
        loading: false,
        initialized: true
      }
    case UserDataActionTypes.USER_DATA_RESET:
      return { ...initialUserDataState }
    case UserDataActionTypes.USER_DATA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    default:
      return state
  }
}
